import { Components, Theme } from "@mui/material/styles";

export const MuiFormControlLabel: Components<Theme>["MuiFormControlLabel"] = {
    styleOverrides: {
        root: {
            "&.Mui-disabled": {
                cursor: "not-allowed",
            },
        },
    },
};
